function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "bg-curvy-mobile_svg__a",
  d: "M0 0h375v141H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "bg-curvy-mobile_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-curvy-mobile_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 128.937c22.708-1.669 44.049-15.69 64.024-42.063 29.962-39.56 23.473-54.118 73.218-40.562 49.746 13.556 45.508 4.677 77.494-26.648 31.985-31.325 52.746-24.157 72.245 13.912 19.499 38.07 55.147 47.264 88.395 61.244 22.165 9.32 22.165 1296.047 0 3860.18H0V128.937z",
  fill: "#181F2B",
  mask: "url(#bg-curvy-mobile_svg__b)"
}));

function SvgBgCurvyMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 141
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzc1IiBoZWlnaHQ9IjE0MSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0wIDBoMzc1djE0MUgweiIvPjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjxwYXRoIGQ9Ik0wIDEyOC45MzdjMjIuNzA4LTEuNjY5IDQ0LjA0OS0xNS42OSA2NC4wMjQtNDIuMDYzIDI5Ljk2Mi0zOS41NiAyMy40NzMtNTQuMTE4IDczLjIxOC00MC41NjIgNDkuNzQ2IDEzLjU1NiA0NS41MDggNC42NzcgNzcuNDk0LTI2LjY0OCAzMS45ODUtMzEuMzI1IDUyLjc0Ni0yNC4xNTcgNzIuMjQ1IDEzLjkxMiAxOS40OTkgMzguMDcgNTUuMTQ3IDQ3LjI2NCA4OC4zOTUgNjEuMjQ0IDIyLjE2NSA5LjMyIDIyLjE2NSAxMjk2LjA0NyAwIDM4NjAuMThIMFYxMjguOTM3eiIgZmlsbD0iIzE4MUYyQiIgbWFzaz0idXJsKCNiKSIvPjwvZz48L3N2Zz4=";
export { SvgBgCurvyMobile as ReactComponent };